import axiosInstance from '../axios/axiosInstance';

export interface ServiceHealth {
  name: string;
  status: 'healthy' | 'unhealthy' | 'unknown';
  responseTime?: number;
  response_time?: number;
  details?: Record<string, any>;
  error?: string;
}

export interface HealthStatus {
  status: string;
  timestamp: string;
  services: ServiceHealth[];
}

export const healthApi = {
  /**
   * Get system health status.
   * Backend returns services as an object keyed by service name.
   * We normalize it to an array for the frontend.
   */
  getStatus: async (): Promise<HealthStatus> => {
    const { data } = await axiosInstance.get('/health');

    // Normalize services from object to array
    let services: ServiceHealth[] = [];
    if (Array.isArray(data.services)) {
      services = data.services;
    } else if (data.services && typeof data.services === 'object') {
      services = Object.entries(data.services).map(([name, svc]: [string, any]) => ({
        name,
        status: svc.status || 'unknown',
        responseTime: svc.response_time ?? svc.responseTime,
        error: svc.error,
      }));
    }

    return {
      status: data.status,
      timestamp: data.timestamp,
      services,
    };
  },
};
